.paginatorRow {
	width: 100%;
	margin-right: 0px !important;
	margin-left: 0px !important;
	display: flex;
	align-items: center;

	.label {
		background-color: #f5f5f5;
		border-radius: 4px;
		font-weight: 500;
		text-align: center;
		font-size: 12px;
		padding: 3px 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 20px;

		span {
			background-color: #5a8217;
			color: white;
			padding: 3px 6px;
			border-radius: 4px;
			white-space: nowrap;
			font-size: 12px;
		}
	}

	.arrow {
		padding: 0;
		cursor: pointer;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: opacity 0.2s;

		&.preview {
			background-image: url("../../assets/images/desktop/flejapaginacion1.svg");
			background-position: center;
			background-repeat: no-repeat;
			background-size: 25px;
		}

		&.next {
			background-image: url("../../assets/images/desktop/flechapaginacion2.svg");
			background-position: center;
			background-repeat: no-repeat;
			background-size: 25px;
		}

		&:hover {
			opacity: 0.6;
		}

		&:active {
			opacity: 0.4;
		}
	}
}

.divMain {
	display: flex;
	margin-right: -35px !important;
	margin-left: -10px !important;
}

.divShow {
	text-align: center;
	padding-right: initial !important;
	padding-left: initial !important;
}

.divPaginate {
	font-weight: 500;
	padding: 0.5em 1em;
	color: #909090;
	padding-left: initial !important;
	padding-right: initial !important;
	text-align: center;
	font-size: 13px;
}

.divDates {
	padding-right: 5px !important;
	padding-left: initial !important;
}

.buttonShow {
	background-color: #f5f7f9;
	border: none;
	color: #909090;
	padding: 7px 15px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 11px;
	font-weight: bold;
	border-radius: 5px;
	cursor: pointer;
	margin-top: 3px;
}

.active {
	color: #f6f6f6;
	background-color: #81ba43;
}

.inputSearchTotal {
	width: 100%;
	padding: 5px 20px;
	display: inline-block;
	border: 1px solid #eef0f2;
	border-radius: 5px;
	box-sizing: border-box;
}

.inputSearchTotal::placeholder {
	font-weight: 500;
	letter-spacing: 1px;
	color: #cbccd3;
}

.inputSearch {
	width: 95%;
	padding: 5px 20px;
	display: inline-block;
	border: 1px solid #eef0f2;
	border-radius: 5px;
	box-sizing: border-box;
}

.inputSearch::placeholder {
	font-weight: bold;
	letter-spacing: 1px;
	color: #cbccd3;
}

.inputUnit {
	width: 100%;
	padding: 6px 12px;
	display: inline-block;
	border: 1px solid #eef0f2;
	border-radius: 5px;
	box-sizing: border-box;
}

.inputUnit::placeholder {
	font-weight: bold;
	letter-spacing: 1px;
	color: #cbccd3;
}

.divFilter {
	width: 100%;
	display: inline-block;
}

.inputDateFrom {
	padding-top: 11px !important;
	padding-bottom: 7px !important;
	font-size: 11px;
	border-radius: initial !important;
	border-top-left-radius: 20px !important;
	border-bottom-left-radius: 20px !important;
}

.inputDateTo {
	padding-top: 11px !important;
	padding-bottom: 7px !important;
	font-size: 11px;
	border-radius: initial !important;
}

.inputFilter {
	display: inline-block;
	width: 45%;

	input {
		width: 100%;
		padding: 5px 15px;
		display: inline-block;
		border: 1px solid #eef0f2;
		border-radius: 5px;
		box-sizing: border-box;
	}

	input::placeholder {
		font-weight: bold;
		letter-spacing: 1px;
		color: #cbccd3;
		font-size: 14px;
	}
}

.bottonFilter {
	display: inline-block;
	width: 10%;

	.icon {
		fill: white;
		width: 1.1em;
		height: 1.1em;
		margin-left: -10px;
	}
}

.buttonCleanFilter {
	width: 100%;
	padding: 5px 15px;
	background-color: #84bf45;
	border: 1px solid #84bf45;
	border-top-right-radius: 20px !important;
	border-bottom-right-radius: 20px !important;
}

.buttonCleanFilter:hover {
	background-color: #4f7b21;
	border: 1px solid #4f7b21;
}

.iconPagination {
	width: 14px;
	cursor: pointer;
	fill: #8a8787;
	margin-top: -4px;
}

@media screen and (max-width: 949px) {
	.divDates {
		padding-right: 15px !important;
		padding-left: 15px !important;
	}
}

.main_pagination {
	display: flex;
	justify-content: center;
	position: absolute;
	bottom: 0;
	margin: auto;
}
.pagination {
	margin: auto !important;
}

.selectUnit {
	display: inline-flex;
	background-color: #5a8217;
	color: white;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	border: none;
	height: 24px;
	align-items: center;
}

.unit {
	text-align: center;
	margin-bottom: 2px;
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: 4px;

	@media (max-width: 768px) {
		margin-bottom: 8px;
	}
}
